import valid from "card-validator";
import i18n from "../../../i18n";
import { CARDS } from "../../../constants/cards.c";
import {
    DEFAULT_PHONE_MAX_LENGTH,
    DEFAULT_PHONE_MIN_LENGTH,
    PHONE_COUNTRY_DATA,
} from "../../../constants/phone-countries.c";
import { FORM_FIELD_NAMES } from "../../../constants/form-field-names";

export const ValidatorMapper = {
    "Card-Validator": () => (value: any, allValues: any) => {
        if (value) {
            let cardType = valid.number(value).card?.type;
            const cardnumberlength = allValues.cardnumber.replace(/\s/g, "").length;
            const cardLength = cardType === "american-express" ? 15 : 16;
            if (
                !cardType ||
                !allValues[CARDS[cardType]] ||
                cardnumberlength !== cardLength
            ) {
                return i18n.t("Validation.InvalidCard");
            }
        }
    },
    "Phone-Validator": () => (value: any, allValues: any) => {
        const country =
            PHONE_COUNTRY_DATA[allValues?.[FORM_FIELD_NAMES.PHONE_COUNTRY_CODE]];
        if (!country) {
            return i18n.t("Validation.PhoneCountryCodeRequired");
        }
        if (value) {
            if (!/^[0-9]+$/.test(value)) {
                return i18n.t("Validation.PhoneDigitsOnly");
            }
            const min = country?.minLength ?? DEFAULT_PHONE_MIN_LENGTH;
            const max = country?.maxLength ?? DEFAULT_PHONE_MAX_LENGTH;
            let digits = value;
            // Accept the customary trunk digit (e.g. 090xxxxxxxx in Japan is
            // the 10-digit national number prefixed with trunk "0")
            if (
                country?.nationalPrefix &&
                digits.length > max &&
                digits.startsWith(country.nationalPrefix)
            ) {
                digits = digits.slice(country.nationalPrefix.length);
            }
            if (digits.length < min || digits.length > max) {
                return min === max
                    ? i18n.t("Validation.PhoneExactLength", { length: max })
                    : i18n.t("Validation.PhoneLengthRange", { min, max });
            }
        }
    },
    "Date-Validator": () => (value:any) => {
        if (value) {
            const values = value.split("/");
            const month = parseInt(values[0]);
            const year = parseInt(values[1]);
            const currDate = new Date();
            const currMonth = currDate.getMonth();
            const currYear = parseInt(currDate.getFullYear().toString().substring(2));
            if (
                month < 1 ||
                month > 12 ||
                (year === currYear && month < currMonth + 1) ||
                year < currYear ||
                isNaN(year)
            ) {
                return i18n.t("Validation.ExpiryDate")
            }
        }
    },
};
